import React, { useEffect, useState } from 'react';

import { useAppSelector } from '../../../../../store';
import { MembersTable } from '../components/MembersTable';
import { useLazyGetMembersQuery } from '../service/members.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';
import { MembersFilters } from '../service/members.interface';

export const MembersContainer = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [tableFilters, setTableFilters] = useState<MembersFilters>({
        email: '',
        first_name: '',
        user_name: '',
    });

    const [getMembers, { data, isFetching, isLoading }] =
        useLazyGetMembersQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: Number(filters.chat) || null,
            };
            getMembers(payload, true);
        }
    }, [filters]);

    const onFiltersUpdate = (update: Partial<MembersFilters>) => {
        setTableFilters({ ...tableFilters, ...update });
    };

    return (
        <MembersTable
            loading={isFetching || isLoading}
            filters={tableFilters}
            onFiltersUpdate={onFiltersUpdate}
            source={data?.members || []}
        />
    );
};
